import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

interface IAutoCompleteWithoutPaginationProps {
  onChange: (event: any, value: any) => void;
  value: any;
  options: any[];
  getOptionLabel: (option: any) => string;
}

export const AutoCompleteWithoutPagination: React.FC<IAutoCompleteWithoutPaginationProps> = ({ onChange, value, options, getOptionLabel }) => {
  return (
    <Autocomplete
      disablePortal
      onChange={onChange}
      value={value}
      options={options}
      getOptionLabel={getOptionLabel}
      renderInput={params => <TextField {...params} required />}
      noOptionsText="Nenhuma opção encontrada"
      sx={{
        '&  .MuiOutlinedInput-root .MuiAutocomplete-input': {
          padding: '0px',
          paddingLeft: '10px',
        },
        '& fieldset': {
          top: '0',
        },
      }}
    />
  );
};
